module.exports = __webpack_public_path__ + "img/jordbruk_smvf.28435582.jpg";